import './index.css'
import cn from 'clsx'

import React from 'react'
type Props = {
  children: React.ReactNode
  space?:
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge'
}

/**
 * A stack component that arranges its children vertically with consistent spacing
 * @param children - The child components to be stacked
 * @param space - The spacing between stack items ('xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', defaults to 'medium')
 * @returns A div container with vertically stacked children
 */
const Stack = ({
  children,
  space = 'medium',
}: Props): React.ReactElement<'div'> => (
  <div
    className={cn({
      'Stack-space--xxsmall': space === 'xxsmall',
      'Stack-space--xsmall': space === 'xsmall',
      'Stack-space--small': space === 'small',
      'Stack-space--medium': space === 'medium',
      'Stack-space--large': space === 'large',
      'Stack-space--xlarge': space === 'xlarge',
      'Stack-space--xxlarge': space === 'xxlarge',
    })}
  >
    {React.Children.map(children, renderChildren)}
  </div>
)

const renderChildren = (child: React.ReactNode, index: number) =>
  child && (
    <div className="Stack-item" key={index}>
      {child}
    </div>
  )

export default Stack
